import React from 'react';
export const Navigation = () => (
  <svg width="201px" height="156px" viewBox="0 0 201 156" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-236.000000, -509.000000)">
        <g transform="translate(236.000000, 509.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M154.2583,152.2074 L176.0033,152.2074"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M46.1167,152.2074 L104.8617,152.2074"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M151.584,94.2563 L151.584,96.2563"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M151.584,100.2563 L151.584,102.2563"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M155.584,98.2563 L153.584,98.2563"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M149.584,98.2563 L147.584,98.2563"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M145.9307,152.6635 C145.9307,154.2695 138.7767,155.5715 129.9517,155.5715 C121.1257,155.5715 113.9717,154.2695 113.9717,152.6635 C113.9717,151.0575 121.1257,149.7555 129.9517,149.7555 C138.7767,149.7555 145.9307,151.0575 145.9307,152.6635"
            fill="#D0D7DA"
          />
          <path
            d="M163.1949,121.3451 C163.1949,122.1831 162.5159,122.8631 161.6769,122.8631 C160.8389,122.8631 160.1589,122.1831 160.1589,121.3451 C160.1589,120.5061 160.8389,119.8261 161.6769,119.8261 C162.5159,119.8261 163.1949,120.5061 163.1949,121.3451"
            fill="#F5C400"
          />
          <path
            d="M131.4795,95.2563 C131.4795,96.0943 130.7995,96.7743 129.9615,96.7743 C129.1235,96.7743 128.4435,96.0943 128.4435,95.2563 C128.4435,94.4173 129.1235,93.7373 129.9615,93.7373 C130.7995,93.7373 131.4795,94.4173 131.4795,95.2563"
            fill="#0B9CE5"
          />
          <g transform="translate(56.000000, 68.710000)">
            <polyline
              fill="#FFFFFF"
              points="64.5972 45.3812 58.0672 4.2092 28.8382 9.9942 36.0742 0.3762 0.4482 7.6822 9.6252 65.7152 36.7792 60.2152 38.0142 68.0272 61.8412 64.2232"
            />
            <polyline
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="64.5972 45.3812 58.0672 4.2092 28.8382 9.9942 36.0742 0.3762 0.4482 7.6822 9.6252 65.7152 36.7792 60.2152 38.0142 68.0272 61.8412 64.2232"
            />
          </g>
          <path
            d="M150.584,131.7426 C150.584,142.9716 141.481,152.0756 130.251,152.0756 C119.022,152.0756 109.919,142.9716 109.919,131.7426 C109.919,120.5136 119.022,111.4106 130.251,111.4106 C141.481,111.4106 150.584,120.5136 150.584,131.7426"
            fill="#FFFFFF"
          />
          <path
            d="M132.773,132.6205 C132.493,131.5575 131.467,131.1045 130.494,131.6155 L130.01,131.8695 C129.036,132.3815 128.825,133.4815 129.542,134.3165 L133.542,138.9745 C134.258,139.8085 134.615,139.6215 134.335,138.5575 L132.773,132.6205 Z"
            stroke="#DDE5E8"
          />
          <path
            d="M127.73,130.8647 C128.01,131.9287 129.036,132.3817 130.01,131.8697 L130.494,131.6157 C131.467,131.1047 131.678,130.0037 130.961,129.1697 L126.962,124.5107 C126.246,123.6767 125.888,123.8637 126.168,124.9277 L127.73,130.8647 Z"
            fill="#FE5E48"
          />
          <path
            d="M127.73,130.8647 C128.01,131.9287 129.036,132.3817 130.01,131.8697 L130.494,131.6157 C131.467,131.1047 131.678,130.0037 130.961,129.1697 L126.962,124.5107 C126.246,123.6767 125.888,123.8637 126.168,124.9277 L127.73,130.8647 Z"
            stroke="#A01603"
          />
          <path
            d="M147.2735,131.7426 C147.2735,141.1436 139.6525,148.7636 130.2515,148.7636 C120.8515,148.7636 113.2305,141.1436 113.2305,131.7426 C113.2305,122.3426 120.8515,114.7216 130.2515,114.7216 C139.6525,114.7216 147.2735,122.3426 147.2735,131.7426 Z"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M145.4102,118.1918 C148.6282,121.7888 150.5842,126.5378 150.5842,131.7428 C150.5842,142.9718 141.4812,152.0758 130.2512,152.0758 C119.0222,152.0758 109.9192,142.9718 109.9192,131.7428 C109.9192,120.5128 119.0222,111.4108 130.2512,111.4108 C133.4772,111.4108 136.5272,112.1618 139.2362,113.4988"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M131.8199,130.9194 C132.2749,131.7854 131.9409,132.8564 131.0749,133.3114 C130.2089,133.7654 129.1379,133.4324 128.6839,132.5654 C128.2289,131.6994 128.5629,130.6294 129.4289,130.1754 C130.2949,129.7204 131.3649,130.0544 131.8199,130.9194"
            fill="#FFFFFF"
          />
          <path
            d="M131.8199,130.9194 C132.2749,131.7854 131.9409,132.8564 131.0749,133.3114 C130.2089,133.7654 129.1379,133.4324 128.6839,132.5654 C128.2289,131.6994 128.5629,130.6294 129.4289,130.1754 C130.2949,129.7204 131.3649,130.0544 131.8199,130.9194 Z"
            stroke="#A01603"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M130.2515,114.7211 L130.2515,117.2921"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M115.5103,123.2319 L117.7373,124.5179"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M115.5103,140.2533 L117.7393,138.9673"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M130.2515,148.7641 L130.2515,146.1941"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144.9927,140.2533 L142.7657,138.9683"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144.9927,123.2319 L142.7647,124.5189"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M130.2515,111.4106 L130.2515,109.3866"
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="128.239 109.386 132.264 109.386 132.264 108.036 128.239 108.036"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="128.239 109.386 132.264 109.386 132.264 108.036 128.239 108.036"
          />
          <polygon
            fill="#FFFFFF"
            points="126.394 108.107 134.121 108.107 134.121 106.757 126.394 106.757"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="126.394 108.107 134.121 108.107 134.121 106.757 126.394 106.757"
          />
          <path
            d="M120.0547,65.3471 C120.0547,65.3471 101.3477,60.6781 99.1497,81.2691"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2,4"
          />
          <path
            d="M99.1382,88.0912 C99.1382,89.3082 98.1512,90.2952 96.9332,90.2952 C95.7162,90.2952 94.7292,89.3082 94.7292,88.0912 C94.7292,86.8732 95.7162,85.8862 96.9332,85.8862 C98.1512,85.8862 99.1382,86.8732 99.1382,88.0912"
            fill="#FFFFFF"
          />
          <path
            d="M99.1382,88.0912 C99.1382,89.3082 98.1512,90.2952 96.9332,90.2952 C95.7162,90.2952 94.7292,89.3082 94.7292,88.0912 C94.7292,86.8732 95.7162,85.8862 96.9332,85.8862 C98.1512,85.8862 99.1382,86.8732 99.1382,88.0912 Z"
            stroke="#F5C400"
          />
          <path
            d="M47.9859,99.8139 C47.9859,101.8889 46.3039,103.5709 44.2289,103.5709 C42.1529,103.5709 40.4709,101.8889 40.4709,99.8139 C40.4709,97.7389 42.1529,96.0559 44.2289,96.0559 C46.3039,96.0559 47.9859,97.7389 47.9859,99.8139"
            fill="#FFFFFF"
          />
          <path
            d="M47.9859,99.8139 C47.9859,101.8889 46.3039,103.5709 44.2289,103.5709 C42.1529,103.5709 40.4709,101.8889 40.4709,99.8139 C40.4709,97.7389 42.1529,96.0559 44.2289,96.0559 C46.3039,96.0559 47.9859,97.7389 47.9859,99.8139 Z"
            stroke="#F5C400"
          />
          <path
            d="M121.9156,61.9125 L121.9156,50.4445"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#FFFFFF"
            points="121.9156 50.4447 130.0096 53.8377 121.9156 57.2297"
          />
          <polygon
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="121.9156 50.4447 130.0096 53.8377 121.9156 57.2297"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="56.4483 76.392 65.5053 67.183 66.5483 74.365"
          />
          <path d="M84.8379,78.7045 L94.0149,136.7365" stroke="#DDE5E8" />
          <path
            d="M92.1162,69.0863 L93.2512,77.0393"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.1084,99.0385 C86.1084,99.0385 73.1084,114.9505 64.7964,105.1025 C56.4844,95.2565 50.6364,99.1065 50.6364,99.1065"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2,4"
          />
          <path
            d="M86.0972,128.6 C86.0972,128.6 84.6372,119.904 92.4612,116.886"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="2,4"
          />
        </g>
      </g>
    </g>
  </svg>
);
